// extracted by mini-css-extract-plugin
module.exports = {"spec_heading":"specs_spec_heading__aN181","divider":"specs_divider__Bh_kc","specs":"specs_specs__tWUcm"};